<template>
    <video
        :src="src"
        :playsinline="initAttribute.playsinline"
        :autoplay="initAttribute.autoplay"
        :muted="initAttribute.muted"
        :loop="initAttribute.loop"
        :controls="initAttribute.controls"
        :poster="initAttribute.poster"
        :preload="initAttribute.preload"
        @play="onPlay(index)"
        @pause="onPause(index)"
        @ended="onEnded(index)"
        @timeupdate="onTimeUpdate($event)"
        @loadedmetadata="onLoadedMeta($event)"
    ></video>
</template>

<script>
export default {
    name: 'VideoCommon',
    props: {
        index: {
            type: Number,
            default: 0
        },
        src: {
            type: String,
            default: ''
        },
        attribute: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            initAttribute: {
                playsinline: true,
                autoplay: false,
                controls: true,
                loop: false,
                muted: false,
                poster: '',
                preload: 'metadata' // auto / metadata / none
            }
        };
    },
    methods: {
        onPlay(index) {
            this.$emit('playVideo', index);
        },

        onPause(index) {
            this.$emit('pauseVideo', index);
        },

        onEnded(index) {
            this.$emit('endedVideo', { index, isEnd: true });
        },

        onTimeUpdate(e) {
            const video = e.target;
            this.$emit('onTimeUpdate', video.currentTime.toFixed(0));
        },

        onLoadedMeta(e) {
            const video = e.target;
            this.$emit('onLoadedMeta', {
                duration: video.duration,
                width: video.videoWidth,
                height: video.videoHeight
            });
        }
    },

    watch: {
        attribute: {
            handler(val) {
                this.initAttribute = { ...this.initAttribute, ...val };
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
